export const PAYERS_PATH = "/member/payers";
export const PAYER_DETAILS_PATH = `${PAYERS_PATH}/:payerId`;
export const PAYER_HISTORY_PATH = `${PAYER_DETAILS_PATH}/history`;
export const PAYERS_REQUIREMENTS_PATH = `${PAYERS_PATH}/requirements`;
export const PAYER_DETAILS_REQUIREMENTS_PATH = `${PAYER_DETAILS_PATH}/requirements`;
export const PAYER_ENGAGEMENT_PATH = `${PAYERS_PATH}/:payerId/engagements/:engagementId`;
export const PAYER_ENGAGEMENT_HISTORY_PATH = `${PAYERS_PATH}/:payerId/engagements/:engagementId/history`;
export const PAYER_REQUIREMENT_DETAIL_PATH = `${PAYER_DETAILS_PATH}/requirement/:requirementId`;

export const getPayerDetailsUrl = (payerId: string) => {
  return PAYER_DETAILS_PATH.replace(":payerId", payerId);
};

export const getPayerHistoryUrl = (payerId: string) => {
  return PAYER_HISTORY_PATH.replace(":payerId", payerId);
};

export const getPayerEngagementUrl = (
  payerId: string,
  engagementId: string
) => {
  return PAYER_ENGAGEMENT_PATH.replace(":payerId", payerId).replace(
    ":engagementId",
    engagementId
  );
};

export const getPayerEngagementHistoryUrl = (
  payerId: string,
  engagementId: string
) => {
  return PAYER_ENGAGEMENT_HISTORY_PATH.replace(":payerId", payerId).replace(
    ":engagementId",
    engagementId
  );
};

export const getPayerDetailsRequirementsUrl = (payerId: string) => {
  return PAYER_DETAILS_REQUIREMENTS_PATH.replace(":payerId", payerId);
};

export const getPayerRequirementDetailUrl = (
  payerId: string,
  requirementId: string
) => {
  return PAYER_REQUIREMENT_DETAIL_PATH.replace(":payerId", payerId).replace(
    ":requirementId",
    requirementId
  );
};
